import useIsMobile from '@/util/useIsMobile'
import { useRecoilValue } from 'recoil'
import { subDataState } from '@/util/states'

import { useApiCall } from 'src/hooks/useApiCall'
import Grid from '../../components/Muse/Grid'
import MuseNav from './navigation';


export async function getStaticProps() {
  return {
    props: {
      title: 'Muses | Beyond the Pines',
      description: 'Explore the muses of Beyond the Pines. Editorials, behind the scenes, and interviews.',
    },
  }
}

export default function MuseBts() {
  const isMobile = useIsMobile()
  const subData = useRecoilValue(subDataState)

  if (isMobile === undefined) return null
  if (subData === 'pending') return null

  return (
    <div className="w-full">
      <div className="dt:max-w-full mx-auto dt:px-6">
        <MuseNav />
        <Grid isMobile={isMobile} subData={subData} />
      </div>
    </div>
  )
}
